import React, { useEffect } from 'react';
import { LoadingState, useWebView } from '@mp';
import { Box, HStack } from '@medely/ui-kit';
import { ReferralContainer } from '../referrals/ReferralContainer';

declare global {
  interface Window {
    impactToken?: string;
  }
}

const ReferralWidget = () => {
  const { setIsWebView } = useWebView();
  const hasToken = window.impactToken;

  useEffect(() => {
    setIsWebView(true);
  }, []);

  if (!hasToken) {
    return (
      <HStack justifyContent="center" alignItems="center" flex={1} height="100vh">
        <LoadingState />
      </HStack>
    );
  }

  return (
    <Box p={1}>
      <ReferralContainer />
    </Box>
  );
};

export default ReferralWidget;
